import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="bg-linen py-16 sm:py-24" aria-labelledby="guarantee-title" data-id="element-42" data-mp="1o5zw0gfxp1bh">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.35
    }} transition={{
      duration: 0.5
    }} className="mx-auto max-w-4xl rounded-[2rem] border border-wool bg-white p-8 shadow-soft sm:p-12" data-id="element-43" data-mp="221bxd6olhq1d">
        <div className="grid items-center gap-10 sm:grid-cols-[auto_1fr] sm:gap-12" data-id="element-44" data-mp="14dl4biwhegc5">
          <motion.div initial={{
          rotate: -12,
          scale: 0.85,
          opacity: 0
        }} whileInView={{
          rotate: -8,
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true,
          amount: 0.5
        }} transition={{
          type: 'spring',
          stiffness: 160,
          damping: 14,
          delay: 0.15
        }} className="mx-auto flex h-48 w-48 shrink-0 flex-col items-center justify-center rounded-full border-4 border-dashed border-terracotta bg-cream text-center text-terracotta" aria-hidden="true" data-id="element-45" data-mp="1j5vc0gfthogi">
            <ShieldCheckIcon className="h-8 w-8" data-id="element-46" data-mp="twi7l834vrpz" />
            <p className="mt-2 px-6 font-display text-lg font-black uppercase leading-tight" data-id="element-47" data-mp="yqdyxrow6gc6">
              Satisfacción Garantizada
            </p>
            <p className="mt-1 text-[11px] font-bold uppercase tracking-[0.18em]" data-id="element-48" data-mp="12sr3wdvtea7w">7 días</p>
          </motion.div>

          <div className="text-center sm:text-left" data-id="element-49" data-mp="azqrf7iw1sq5">
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-terracotta" data-id="element-50" data-mp="b0a7sjsw4922">
              Garantía de hierro
            </span>
            <h2 id="guarantee-title" className="mt-3 font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-51" data-mp="k0f4o00gjp1z">
              Si en 7 días no tejiste tu primera pieza, te devolvemos el 100% de tu dinero
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-52" data-mp="1vdr31vdg7fgr">
              El riesgo es cero: probá el método completo durante una semana. Si sentís que no es
              para vos, escribinos y te reintegramos hasta el último peso. Queremos tejedoras
              felices, no clientes insatisfechas.
            </p>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-xl" data-id="element-53" data-mp="c5rheh2mw22">
          <CtaButton data-id="element-54" data-mp="acfdjnovjmo" />
        </div>
      </motion.div>
    </section>;
}